// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-802289a8] .icon-view-extended {\n  margin-bottom: 0.5rem;\n}\n[data-v-802289a8] .icon-view-extended .dot {\n  margin-right: 0.5rem !important;\n  width: 40px !important;\n  height: 40px !important;\n}\n[data-v-802289a8] .icon-view-extended .dot .title-icon {\n  margin: 0 !important;\n}\n[data-v-802289a8] .icon-view-extended .font-16.color-gray-7 {\n  font-size: 24px !important;\n}\n.bg-greyish-green[data-v-802289a8] {\n  background-color: #f4f6f3;\n}", ""]);
// Exports
module.exports = exports;
